import { render, staticRenderFns } from "./SelectRoles.vue?vue&type=template&id=504a8a76&"
import script from "./SelectRoles.vue?vue&type=script&lang=js&"
export * from "./SelectRoles.vue?vue&type=script&lang=js&"
import style0 from "./SelectRoles.vue?vue&type=style&index=0&id=504a8a76&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports